module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/unzip_imgs.worker.7404a26c1c442e7e909f.js");
}
